export default from './profile-photo';



// WEBPACK FOOTER //
// ./app/components/profile-photo/index.js